module.exports = __webpack_public_path__ + "img/Differentiation-PRCA_10X_ACC.055b6cca.png";